// 发卡器断开连接
export const READER_DISCONNECT = '@Closed';
// nfc发卡器已连接
export const NFC_READER_CONNECT = '@NFCEncoder';
// ble发卡器已连接
export const BLE_READER_CONNECT = '@BLEEncoder';
// nfc钥匙已连接
export const NFC_KEY_CONNECT = '@NFCKey';
// ble钥匙已连接
export const BLE_KEY_CONNECT = '@BLEKey';

// 钥匙内存储的事件类型
export const KEY_EVENT_TYPES = {
  UNLOCK_SUCCESS: 1,
  SETTING_SUCCESS: 2,
  SETTING_FAILED: 3,
  EXPIRED_KEY: 4,
  NO_UNLOCK_PERMISSION: 5,
  OUTOF_LOCK_TIME: 6,
  WRONG_SYSCODE: 7,
  BLACKLISTS: 8,
  ERROR_COMMUNICATION: 9,

  // TODO: 剩下的暂时还没写...
};
